<template>
  <div class="error-box text-center px-3">
    <img src="@/assets/img/error/img-01.svg" alt="img" class="img-fluid bg-01" />
    <img src="@/assets/img/error/img-02.svg" alt="img" class="img-fluid bg-02" />
    <img src="@/assets/img/error/img-03.svg" alt="img" class="img-fluid bg-03" />
    <img src="@/assets/img/error/img-04.svg" alt="img" class="img-fluid bg-04" />
    <img src="@/assets/img/error/img-05.svg" alt="img" class="img-fluid bg-05" />
    <img src="@/assets/img/error/img-06.svg" alt="img" class="img-fluid bg-06" />
    <div class="error-logo">
      <router-link to="/home">
        <img src="@/assets/logo/sapta.png" class="img-fluid" alt="Logo" style="max-width: 12vw"/>
      </router-link>
    </div>
    <div class="error-box-img">
      <img src="@/assets/img/error/error-01.svg" alt="Img" class="img-fluid" />
    </div>
    <h3 class="h2 mb-3">Oh No! Error <span class="text-secondary ms-1">404</span></h3>
    <p class="h4 font-weight-normal mb-4">
      This page you requested could not be found. Please check the URL or return to
      a safe page.
    </p>
    <div class="d-flex flex-column flex-sm-row justify-content-center gap-3">
      <router-link to="/home" class="btn back-to-home-btn">
        <i class="isax isax-arrow-left-2 me-1"></i> Back to Home
      </router-link>
      <button type="button" class="btn btn-light" @click="goBack">
        <i class="isax isax-arrow-left-2 me-1"></i> Back to Previous
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, onBeforeUnmount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth-store";

export default defineComponent({
  name: "Error404Page",
  setup() {
    const router = useRouter();

    const goBack = () => {
      const auth = useAuthStore();
      const role = String(auth.role || "").toLowerCase();
      if (role === "principal") {
        router.push("/principal/Course");
        return;
      }
      if (role === "teacher") {
        router.push("/instructor/instructor-course");
        return;
      }
      if (role === "student") {
        router.push("/students/student-dashboard");
        return;
      }
      router.push("/home");
    };

    onMounted(() => {
      document.body.classList.add("error-page");
    });

    onBeforeUnmount(() => {
      document.body.classList.remove("error-page");
    });

    return { goBack };
  },
});
</script>
